import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M3 9V15H7L12 20V4L7 9H3Z" />,
  'VolumeMute',
)
